export default __webpack_public_path__ + "static/default-b-c4ac61191188218140a4f492a7043b42.png";